import { WSFormProps, WSList, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useUserId } from "../../../../../query/hooks/helpers";
import { verificationService } from "../../../../../shared/services/verificaiton";

import { getUsPersonData } from "../../../components/FormUSInternationalPersonInformation/getUsPersonData";
import { OnboardingModuleCreateAccount } from "../../../types";
import { useOnboardignModules, useOnboardingContext } from "../../../Context";
import { CreateAccountContext } from "../../../steps/CreateAccount/types";
import { useQueryPrimaryComplianceEntity } from "../../../../../shared/hooks/useQueryPrimaryComplianceEntity";
import {
  FormDataUSInternationalPersonInformation,
  FormUSInternationalPersonInformation
} from "../../../components/FormUSInternationalPersonInformation";
import { useUsPersonMissingFields } from "../../../hooks/useUsPersonMissingFields";
import { CardTaxVerificationRequirementRequester } from "../../../components/CardTaxVerificationRequirementRequester";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { FlowMEChangeContext } from "../index";
import { FlowStep } from "../../../../../shared/components/FlowSwitch/types";

export const StepMaterialInternationalUSPersonInformation: React.FC<
  FlowStep
> = ({ onNext, onBack }) => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();

  const queryComplianceEntity = useQueryPrimaryComplianceEntity();

  const usPersonData: WSFormProps<FormDataUSInternationalPersonInformation>["defaultValues"] =
    useMemo(
      () => ({
        usPerson: getUsPersonData(queryComplianceEntity.data)
      }),
      [queryComplianceEntity.data]
    );

  const modules = useOnboardignModules();
  const onboardingModule = modules.find(m => m.type === "create_account") as
    | OnboardingModuleCreateAccount
    | undefined;
  const verificationLevel =
    onboardingModule?.options?.verificationLevel || "Tax";

  const usPersonMissingFields = useUsPersonMissingFields(verificationLevel);

  const isUsPersonMismatch = useMemo(
    () => verificationService.getIsUsPersonMismatch(usPersonMissingFields),
    [usPersonMissingFields]
  );

  return (
    <WSList gap="2XL">
      <CardTaxVerificationRequirementRequester />

      <FormUSInternationalPersonInformation
        defaultValues={context.usInternationalPersonInformation || usPersonData}
        onBack={onBack}
        onSubmit={data => {
          setContext(prev => ({
            ...prev,
            usInternationalPersonInformation: data
          }));
          onNext?.();
        }}
        mismatch={isUsPersonMismatch}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
